import * as React from 'react';

function SvgIconTickSuccess(props) {
  return (
    <svg width={80} height={80} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#F8F8F6" cx={40} cy={40} r={40} />
        <path
          d="M26.6 37.29a3.17 3.17 0 00-4.48 0l-1.2 1.2a3.18 3.18 0 000 4.48l11.16 11.16a3.15 3.15 0 004.5-.02l22.48-22.5a3.18 3.18 0 00.01-4.5l-1.19-1.19a3.2 3.2 0 00-4.5.01L34.32 45l-7.71-7.71z"
          fill="#FCCE01"
        />
      </g>
    </svg>
  );
}

export default SvgIconTickSuccess;
